<template>

  <div id="dlnkaap_reponse_porteur">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <dlnkwait :wait_data="wait_data"></dlnkwait>

    <!-- ========== MAIN ========== -->
    <main id="content" role="main" class="bg-light">
      <!-- Breadcrumb Section -->
      <div class="bg-primary" style="background-image: url(/themes/template/img/components/subtle-prism4.png);">
        <div class="container-fluid">
          <div class="row d-flex justify-content-between p-3">

            <div class="col-lg-6">
              <h2 v-if="admin" class="text-white my-auto">Admin du jury ({{ aaps_count }} projets filtrés)</h2>
              <h2 v-else class="text-white my-auto">Mes projets</h2>
            </div>
            <div v-if="admin" class="col-lg-3">
              <div class="d-block ">
                <div class="d-flex justify-content-end">
                  <ul class="nav nav-segment">
                    <li class="list-inline-item">
                      <a class="nav-link" v-bind:class="{ active: view === 'map' }" href="javascript:void(0)" @click="view = 'map'">
                        <i class="fas fa-map"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a class="nav-link" v-bind:class="{ active: view === 'chart' }" href="javascript:void(0)" @click="view = 'chart'">
                        <i class="fas fa-chart-pie"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a class="nav-link" v-bind:class="{ active: view === 'table' }" href="javascript:void(0)" @click="view = 'table'">
                        <i class="fa fa-tasks" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

            <div v-if="admin" class="row">

              <div class="form-group col-md-6">
                <label for="referent_select" class="text-white">Référent :</label>
                <vue-select
                    multiple
                    class="vue-select1"
                    name="referent_select"
                    label="name"
                    :options="referents"
                    v-model="filter_referent"
                    :reduce="referents => referents.id"
                >
                </vue-select>
              </div>

              <div class="form-group col-md-6">
                <label for="axe_select" class="text-white">Axe :</label>
                <vue-select
                    multiple
                    class="vue-select1"
                    name="axe_select"
                    :options="axes"
                    v-model="filter_axe"
                >
                </vue-select>
              </div>

              <div class="form-group col-md-6">
                <label for="axe_select" class="text-white">Commission :</label>
                <vue-select
                    multiple
                    class="vue-select1"
                    name="axe_select"
                    :options="commissions"
                    label="date_commission_fr"
                    v-model="filter_commission"
                    :reduce="commissions => commissions.id"
                >
                </vue-select>
              </div>

              <div class="form-group col-md-6">
                <label for="axe_select" class="text-white">Statut juridique :</label>
                <vue-select
                    multiple
                    class="vue-select1"
                    name="axe_select"
                    :options="statut_juridiques"
                    v-model="filter_statut_juridique"
                >
                </vue-select>
              </div>

            </div>
          </div>
        </div>

      <!-- Content Section -->
      <div class="container-fluid space-1 py-3 mb-2">
        <div class="row">

          <div class="col-12">
            <!-- Card -->
            <div class="card">

              <!-- Card -->
              <div class="card card-bordered overflow-hidden m-2">

                <div class="row">

                  <div class="col-12">
                    <p v-if="show_archived" class="alert alert-warning mx-4 mt-2">
                      Attention, vous voyez les projets traités
                    </p>
                    <p v-if="show_deleted" class="alert alert-danger mx-4 mt-2">
                      Attention, vous voyez les projets supprimés
                    </p>
                  </div>

                  <div v-if="admin" class="col-12">

                    <!-- SEARCH -->
                    <div class="d-flex mb-3 px-3">
                      <div class="col-sm-12 col-md-6 col-lg-8 mt-2 px-2">
                        <h4 class="h4">Rechercher</h4>
                        <input type="search" placeholder="Par thème ou par titre…"
                               class="form-control form-control-sm border" v-model="query" style="height: 52px">
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-4 mt-2 px-2">
<!--                        <h4 class="h4">Statut</h4>-->
<!--                        <select class="custom-select" v-model="status_filter">-->
<!--                          <option selected value="">Retirer le filtre</option>-->
<!--                          <option v-for="status in statuses" :key="status.value" :id="'status_' + status.value"-->
<!--                                  :value="status.value">{{ status.name }}-->
<!--                          </option>-->
<!--                        </select>-->
                      </div>
                    </div>
                    <!-- END SEARCH -->


                    <!--                    <div class="alert alert-info mx-4 my-2">-->
                    <!--                      Sélectionner les filtres pour afficher les projets-->
                    <!--                    </div>-->

                    <div class="d-flex justify-content-end pr-4">
                      <div class="custom-control custom-checkbox d-inline mx-4">
                        <input type="checkbox" v-model="show_archived" :value="show_archived"
                               class="custom-control-input" id="show_archived">
                        <label class="custom-control-label text-lh-lg text-success font-weight-bold"
                               for="show_archived">
                          Voir les projets traités
                        </label>
                      </div>

                      <div class="custom-control custom-checkbox d-inline">
                        <input type="checkbox" v-model="show_deleted" :value="show_deleted"
                               class="custom-control-input" id="show_deleted">
                        <label class="custom-control-label text-lh-lg text-danger font-weight-bold" for="show_deleted">
                          Voir les projets supprimés
                        </label>
                      </div>

                      <div class="custom-control custom-checkbox d-inline mx-4">
                        <button type="button" class="btn btn-sm btn-primary" @click="download_report">
                          <i class="fa fa-file-excel" aria-hidden="true"></i> &nbsp;
                          Télécharger
                        </button>
                      </div>

                    </div>

                    <!--                    <div v-for="status in statuses" :key="status.value" class="custom-control custom-checkbox d-inline ml-2">-->
                    <!--                      <input type="checkbox" class="custom-control-input" :id="'status_' + status.value" v-model="status_filter" :value="status.value">-->
                    <!--                      <label class="custom-control-label text-lh-lg" :for="'status_' + status.value">-->
                    <!--                        {{status.name}}-->
                    <!--                      </label>-->
                    <!--                    </div>-->
                  </div>
                </div>

                <div v-if="view === 'chart'">

                  <div class="row">

                    <div class="col-lg-3">
                      <div class="d-flex justify-content-start">
                        <ul class="nav nav-segment mx-2">
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="nav-link"
                               v-bind:class="{ active: view_bar }" @click="view_pie = false; view_bar = true">
                              <i aria-hidden="true" class="fa fa-chart-bar"></i>
                            </a>
                          </li>
                          <li class="list-inline-item">
                            <a href="javascript:void(0)" class="nav-link"
                               v-bind:class="{ active: view_pie }" @click="view_pie = true; view_bar = false">
                              <i class="fas fa-chart-pie"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-xl-3 col-lg-6">

                      <div class="card">
                        <div class="card-body">
                          <h4 class="header-title mb-4">Montants demandés ({{montant_demande}}€)</h4>
                          <div dir="ltr">
                            <div class="mt-3 chartjs-chart" style="height: 320px;">

                              <Pie v-if="view_pie"
                                  :chart-options="chart_options"
                                  :chart-data="chart_demande_data"
                                  chart-id="chart_demande"
                                  :dataset-id-key="datasetIdKey"
                                  :css-classes="cssClasses"
                                  :styles="styles"
                                  :width="width"
                                  :height="height"
                              />

                              <Bar v-if="view_bar"
                                  :chart-options="chart_options"
                                  :chart-data="chart_demande_data"
                                  chart-id="chart_demande"
                                  :dataset-id-key="datasetIdKey"
                                  :css-classes="cssClasses"
                                  :styles="styles"
                                  :width="width"
                                  :height="height"
                              />

<!--                              <canvas id="pie-chart-demande" width="800" height="450"></canvas>-->

                              <!--            <canvas id="pie-example" data-colors="#727cf5,#fa5c7c,#0acf97,#ebeff2, #f56f36" style="box-sizing: border-box; display: block; height: 320px; width: 534px;" width="1068" height="640"></canvas>-->
                            </div>
                          </div>
                        </div> <!-- end card body-->
                      </div>

                    </div>
                    <div class="col-xl-3 col-lg-6">

                      <div class="card">
                        <div class="card-body">
                          <h4 class="header-title mb-4">Montants proposés ({{montant_propose }}€)</h4>
                          <div dir="ltr">
                            <div class="mt-3 chartjs-chart" style="height: 320px;">
                              <Bar
                                  :chart-options="chart_options"
                                  :chart-data="chart_propose_data"
                                  chart-id="chart_demande"
                                  :dataset-id-key="datasetIdKey"
                                  :css-classes="cssClasses"
                                  :styles="styles"
                                  :width="width"
                                  :height="height"
                              />

                              <!--                              <canvas id="pie-chart-propose" width="800" height="450"></canvas>-->

                              <!--            <canvas id="pie-example" data-colors="#727cf5,#fa5c7c,#0acf97,#ebeff2, #f56f36" style="box-sizing: border-box; display: block; height: 320px; width: 534px;" width="1068" height="640"></canvas>-->
                            </div>
                          </div>
                        </div> <!-- end card body-->
                      </div>

                    </div>
                    <div class="col-xl-3 col-lg-6">

                      <div class="card">
                        <div class="card-body">
                          <h4 class="header-title mb-4">Montants décidés ({{montant_decide }}€)</h4>
                          <div dir="ltr">
                            <div class="mt-3 chartjs-chart" style="height: 320px;">
                              <Bar
                                  :chart-options="chart_options"
                                  :chart-data="chart_decide_data"
                                  chart-id="chart_decide"
                                  :dataset-id-key="datasetIdKey"
                                  :css-classes="cssClasses"
                                  :styles="styles"
                                  :width="width"
                                  :height="height"
                              />

                              <!--                              <canvas id="pie-chart-decide" width="800" height="450"></canvas>-->

                              <!--            <canvas id="pie-example" data-colors="#727cf5,#fa5c7c,#0acf97,#ebeff2, #f56f36" style="box-sizing: border-box; display: block; height: 320px; width: 534px;" width="1068" height="640"></canvas>-->
                            </div>
                          </div>
                        </div> <!-- end card body-->
                      </div>

                    </div>
                    <div class="col-xl-3 col-lg-6">

                      <div class="card">
                        <div class="card-body">
                          <h4 class="header-title mb-4">Montants attribués ({{ montant_attribue }}€)</h4>
                          <div dir="ltr">
                            <div class="mt-3 chartjs-chart" style="height: 320px;">
                              <Bar
                                  :chart-options="chart_options"
                                  :chart-data="chart_attribue_data"
                                  chart-id="chart_decide"
                                  :dataset-id-key="datasetIdKey"
                                  :css-classes="cssClasses"
                                  :styles="styles"
                                  :width="width"
                                  :height="height"
                              />

                              <!--                              <canvas id="pie-chart-attribue" width="800" height="450"></canvas>-->

                              <!--            <canvas id="pie-example" data-colors="#727cf5,#fa5c7c,#0acf97,#ebeff2, #f56f36" style="box-sizing: border-box; display: block; height: 320px; width: 534px;" width="1068" height="640"></canvas>-->
                            </div>
                          </div>
                        </div> <!-- end card body-->
                      </div>


                    </div>
                  </div>

                </div>
                <div v-else-if="view === 'table'" >
                <div class="row">

                  <div class="col-12 mt-3">

                    <!-- Pagination -->
                    <div class="mt-2">
                      <dlnkpagination
                          :page="page"
                          :page_count="page_count"
                          :items_count="aaps_count"
                          @next_page="next_page()"
                          @prev_page="prev_page()"
                          @set_page="set_page($event)">
                      </dlnkpagination>
                    </div>
                    <!-- End Pagination -->
                  </div>

                  <!--                  page_count: Number,-->
                  <!--                  from: 0,-->
                  <!--                  to: 0,-->


                </div>
                <div id="coursesCollapseOne" class="collapse show" aria-labelledby="coursesHeadingOne">

                  <!-- Table -->
                  <div class="table-responsive">
                    <table class="table table-borderless table-thead-bordered table-nowrap table-align-middle">
                      <thead class="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Projet</th>
                        <th v-if="admin">Statut juridique</th>
                        <th>Structure</th>
                        <th v-if="admin">Montant demandé</th>
                        <th v-if="admin">Montant alloué</th>
                        <th v-if="admin">Comité technique</th>
                        <th v-if="admin">Commission</th>
                        <th>Référent</th>
                        <th>Statut</th>
                        <th>Actions</th>
                        <!--                        <th>Appel à participation</th>-->
                      </tr>

<!--                      <tr>-->
<!--                        <th>#</th>-->
<!--                        <th>Projet</th>-->
<!--                        <th>Structure</th>-->
<!--                        <th>Montant demandé</th>-->
<!--                        <th>Montant alloué</th>-->
<!--                        <th>Comité technique</th>-->
<!--                        <th>Commission</th>-->
<!--                        <th>Référent</th>-->
<!--                        <th>Statut</th>-->
<!--                        <th>Actions</th>-->
<!--                        &lt;!&ndash;                        <th>Appel à participation</th>&ndash;&gt;-->
<!--                      </tr>-->

                      </thead>
                      <tbody>
                      <tr v-for="aap in aaps" :key="aap.id">
                        <td>
                          {{ aap.id }}
                        </td>
                        <td>
<!--                          <div class="media align-items-center">-->
<!--                            <img class="avatar avatar-sm avatar-circle mr-3"-->
<!--                                 :src="aap.logo_structure || '/modules/dlnkaap/img/socialmedia.jpg'"-->
<!--                                 alt="Image Description">-->

<!--                            <div class="media-body">-->
                              <a class="d-inline-block text-dark" href="#">
                                <h6 class="text-hover-primary mb-0">{{ aap.projet_nom }}</h6>
                              </a>
<!--                            </div>-->
<!--                          </div>-->
                        </td>
                        <td v-if="admin">
                          {{ aap.statut_juridique }}
                        </td>
                        <td class="align-middle">
                          {{ aap.nom }}
                        </td>

                        <td v-if="admin" class="align-middle">
                          {{ aap.subvention_sollicitee }}
                        </td>

                        <td v-if="admin" class="align-middle">
                          {{ aap.montant_attribue }}
                        </td>

                        <td v-if="admin" style="white-space: nowrap;" class="align-middle">
                          <div class="form-group">
                            <form :id="'aap_comite_technique_form_' + aap.id"
                                  method="post"
                                  @submit.prevent="set_date_comite_technique(aap.id)">

                              <select :id="'comite_technique_id_' + aap.id" name="aap[comite_technique_id]">
                                <option value="0"
                                        :selected="aap.comite_technique.id == 0 ? true : false">
                                  Date de comite technique
                                </option>
                                <option v-for="comite in comite_techniques" :key="comite.id"
                                        :value="comite.id"
                                        :selected="comite.id == aap.comite_technique.id ? true : false">
                                  {{ comite.date_comite_technique_fr }}
                                </option>
                              </select>

                              <button type="submit" class="btn-success">
                                <i class="fa fa-check"></i>
                              </button>
                            </form>
                          </div>
                        </td>

                        <td v-if="admin" style="white-space: nowrap;" class="align-middle">
                          <div class="form-group">
                            <form :id="'aap_commission_form_' + aap.id"
                                  method="post"
                                  @submit.prevent="set_date_commission(aap.id)">

                              <select :id="'commission_id_' + aap.id" name="aap[commission_id]">
                                <option value="0"
                                        :selected="aap.commission.id == 0 ? true : false">
                                  Date de commission
                                </option>
                                <option v-for="commission in commissions" :key="commission.id"
                                        :value="commission.id"
                                        :selected="commission.id == aap.commission.id ? true : false">
                                  {{ commission.date_commission_fr }}
                                </option>
                              </select>

                              <button type="submit" class="btn-success">
                                <i class="fa fa-check"></i>
                              </button>
                            </form>
                          </div>
                        </td>

                        <td style="white-space: nowrap;" class="align-middle">
                          <div v-if="admin" class="form-group">
                            <form :id="'aap_referent_form_' + aap.id"
                                  method="post"
                                  @submit.prevent="set_referent(aap.id)">

                              <select :id="'referent_id_' + aap.id" name="aap[referent_id]">
                                <option value="0"
                                        :selected="aap.referent.id == 0 ? true : false">
                                  Réferent
                                </option>
                                <option v-for="referent in referents" :key="referent.id"
                                        :value="referent.id"
                                        :selected="referent.id == aap.referent.id ? true : false">
                                  {{ referent.name }}
                                </option>
                              </select>

                              <button type="submit" class="btn-success">
                                <i class="fa fa-check"></i>
                              </button>
                            </form>
                          </div>
                          <div v-else class="form-group">
                            {{aap.referent.name }}
                          </div>
                        </td>

                        <td style="white-space: nowrap;" class="align-middle">
                          <div v-if="admin" class="form-group">
<!---->
                            <form :id="'aap_status_form_' + aap.id"
                                  method="post"
                                  @submit.prevent="set_status(aap.id)">
<!---->
                              <select :id="'status_id_' + aap.id"
                                      name="aap[aap_status_histories_attributes][0][status_id]">
                                <option v-for="status in statuses" :key="status.id"
                                        :value="status.id"
                                        :selected="status.name == aap.status ? true : false">
                                  {{ status.name }}
                                </option>
                              </select>

                              <button type="submit" class="btn-success">
                                <i class="fa fa-check"></i>
                              </button>
                            </form>
                          </div>
                          <div v-else>{{aap.status}}</div>
                        </td>
<!--                        <td class="align-middle">-->
<!--                          &lt;!&ndash; Select &ndash;&gt;-->
<!--                          <span class="d-flex">-->
<!--                            {{ aap.creation }}-->
<!--                          </span>-->
<!--                          &lt;!&ndash; End Select &ndash;&gt;-->
<!--                        </td>-->
<!--                        <td class="align-middle">-->
<!--                          &lt;!&ndash; Select &ndash;&gt;-->
<!--                          <span class="d-flex">-->
<!--                            {{ aap.maj }}-->
<!--                          </span>-->
<!--                          &lt;!&ndash; End Select &ndash;&gt;-->
<!--                        </td>-->
                        <!--Formulaire réponse-->
                        <td style="white-space: nowrap;">

                          <div class="mb-1">
                              <a  v-if="admin || aap.status_value < 4" class="btn btn-primary btn-sm" title="Modifier / Reprendre"
                                 :href="'/module/dlnkaap/candidature?aap_id=' + aap.id">
                                <i class="fas fa-edit fa-fw"></i>
                              </a>

                              <a v-if="admin" :href="'/module/dlnkaap/jury_extraction?id=' + aap.id" class="btn btn-info btn-sm"
                                 data-tooltip="tooltip" title="Jury">
                                <i class="fas fa-gavel fa-fw"></i>
                              </a>

                              <a class="btn btn-info btn-sm" title="Visualiser le PDF"
                                 :href="'/module/dlnkaap/formulaire_pdf?aap_id=' + aap.id">
                                <i class="fas fa-file-pdf fa-fw"></i>
                              </a>

                            <button class="btn btn-info btn-sm"  title="Cloner le projet"
                               @click="clone_project(aap.id)">
                              <i class="fas fa-clone fa-fw"></i>
                            </button>

                          </div>
                          <div v-if="admin">
                            <button v-if="admin" type="button" @click="destroy(aap.id)" class="btn btn-danger btn-sm"
                                    data-tooltip="tooltip" title="Supprimer">
                              <i class="fas fa-times fa-fw"></i>
                            </button>

                            <button v-if="aap.archived" type="button" @click="activate(aap.id)" data-tooltip="tooltip"
                                    title="Remettre en prod"
                                    class="btn btn-success btn-sm">
                              <i class="fas fa-rocket fa-fw"></i>
                            </button>
                            <button v-else type="button" @click="archive(aap.id)" data-tooltip="tooltip" title="Traité"
                                    class="btn btn-warning btn-sm">
                              <i class="fas fa-archive fa-fw"></i>
                            </button>

                            <button v-if="aap.mise_en_avant" type="button" @click="mise_en_avant(aap.id, 0)" data-tooltip="tooltip"
                                    title="Supprimé la mise en avant"
                                    class="btn btn-warning btn-sm">
                              <i class="fas fa-eye-slash fa-fw"></i>
                            </button>
                            <button v-else type="button" @click="mise_en_avant(aap.id, 1)" data-tooltip="tooltip" title="Mettre en avant"
                                    class="btn btn-success btn-sm">
                              <i class="fas fa-eye fa-fw"></i>
                            </button>

                          </div>

                        </td>

                        <!--Appel à participation-->
                        <!--                        <td>-->
                        <!--                          <a class="btn btn-success btn-sm"-->
                        <!--                             href="{$link->getModuleLink('dlnkaap', 'appel_crowdfunding')|escape:'html'}">-->
                        <!--                            Appel à participation-->
                        <!--                          </a>-->
                        <!--                        </td>-->
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- End Table -->

                </div>
                </div>
                <div v-else-if="view === 'map'" >
                  <dlnkaap-liste-reponses_map :aaps="aaps"></dlnkaap-liste-reponses_map>
                </div>
              </div>
              <!-- End Card -->

            </div>
            <!-- End Card -->
          </div>
        </div>
        <!-- End Row -->
      </div>
      <!-- End Content Section -->
    </main>
    <!-- ========== END MAIN ========== -->

  </div>
</template>


<script>
import { Bar } from 'vue-chartjs/legacy'
import { Pie } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement)

export default {
  components: { Bar, Pie },
  props: {},
  data: function () {
    return {
      admin: false,

      demande_sante: 0,
      demande_famille: 0,
      demande_insertion: 0,
      demande_logement: 0,
      demande_autonomie: 0,

      propose_sante: 0,
      propose_famille: 0,
      propose_insertion: 0,
      propose_logement: 0,
      propose_autonomie: 0,

      decide_sante: 0,
      decide_famille: 0,
      decide_insertion: 0,
      decide_logement: 0,
      decide_autonomie: 0,

      attribue_sante: 0,
      attribue_famille: 0,
      attribue_insertion: 0,
      attribue_logement: 0,
      attribue_autonomie: 0,

      datasetIdKey: 'label',
      width: 400,
      height: 400,
      cssClasses: '',
      styles: {},
      // plugins: {},
      chart_demande_data: {
        labels: [
          "Autonomie (Handicap et Senior)",
          "Famille / Jeunesse",
          "Insertion et action sociale",
          "Logement et mixité sociale",
          "Santé et petite enfance",
        ],
        datasets: [ { data: [0, 0, 0, 0, 0] } ]
      },

      chart_propose_data: {
        labels: [
          "Autonomie (Handicap et Senior)",
          "Famille / Jeunesse",
          "Insertion et action sociale",
          "Logement et mixité sociale",
          "Santé et petite enfance",
        ],
        datasets: [ { data: [0, 0, 0, 0, 0] } ]
      },

      chart_decide_data: {
        labels: [
          "Autonomie (Handicap et Senior)",
          "Famille / Jeunesse",
          "Insertion et action sociale",
          "Logement et mixité sociale",
          "Santé et petite enfance",
        ],
        datasets: [ { data: [0, 0, 0, 0, 0] } ]
      },

      chart_attribue_data: {
        labels: [
          "Autonomie (Handicap et Senior)",
          "Famille / Jeunesse",
          "Insertion et action sociale",
          "Logement et mixité sociale",
          "Santé et petite enfance",
        ],
        datasets: [ { data: [0, 0, 0, 0, 0] } ]
      },

      chart_options: {
        responsive: true,
        backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
      },

      message: "",
      message_type: "",
      wait_data: true,

      view: 'table',
      view_pie: false,
      view_bar: true,
      from: 0,
      to: 0,
      page: 1,
      status_filter: [],
      show_archived: false,
      show_deleted: false,
      query: "",

      montant_demande: 0,
      montant_propose: 0,
      montant_decide: 0,
      montant_attribue: 0,

      filter_axe: [],
      axes: [],
      filter_commission: [],
      commissions: [],
      filter_referent: [],
      referents: [],
      statut_juridiques: [],
      filter_statut_juridique: [],

      customer: Object,
      aaps: Array,
      page_count: Number,
      aaps_count: Number,
      statuses: Array,
      comite_techniques: Array,

    }
  },
  mounted() {
    const _this = this
    this.get_data()
    this.axes = [
        'A classer',
        'Autonomie (Handicap et Senior)',
        'Famille / Jeunesse',
        'Insertion et action sociale',
        'Logement et mixité sociale',
        'Santé et petite enfance',
    ]

    this.statut_juridiques = [
      'A classer',
      "Association",
      "Collectivité territoriale",
      "Entreprise",
      "Établissement public",
      "Établissement scolaire",
      "EPCI",
    ]

  },

  computed: {},

  watch: {

    view: function () {
      this.get_data()
    },

    filter_axe : function () {
      this.get_data()
    },

    filter_referent: function () {
      this.get_data()
    },

    filter_commission : function () {
      this.get_data()
    },

    filter_statut_juridique : function () {
      this.get_data()
    },

    query: function (new_val, old_val) {
      if (new_val.length > 2) {
        this.get_data()
      }
    },

    show_archived: function (new_val, old_val) {
      this.get_data()
    },

    show_deleted: function (new_val, old_val) {
      this.get_data()
    },

    status_filter: function (new_val, old_val) {
      this.get_data()
    },

    page: function (new_val, old_val) {

      if (new_val < 1) {
        this.page = 1
      }

      if (new_val > this.page_count) {
        this.page = this.page_count
      }

      this.get_data()
    },

  },

  methods: {

    download_report: async function() {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/report.xlsx"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios({
        url: api_url,
        method: 'GET',
        responseType: 'blob',
      }).then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'projets.xlsx');
        document.body.appendChild(link);
        link.click();
      })
    },

    mise_en_avant: async function (id, value) {
      const _this = this;

      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/" + id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      const form_data = new FormData();
      form_data.append('aap[mise_en_avant]', value)

      axios({
        method: 'patch',
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.get_data()
            _this.message = "Projet modifié"
            _this.message_type = "alert-success"
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },


    set_page: function (page) {
      page = parseInt(page)
      this.page = page
    },

    next_page: function () {
      this.page++
    },

    prev_page: function () {
      this.page--
    },

    close_message: function () {
      this.message = null;
    },

    archive: async function (id) {
      const _this = this;

      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/" + id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      // const form_element = new HTMLFormElement()
      const form_data = new FormData();

      form_data.append('aap[archived]', 1)

      axios({
        method: 'patch',
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.get_data()
            _this.message = "Projet traité"
            _this.message_type = "alert-success"
          })
          .catch(function (error) {
            if (error.response.status === 401) {
              _this.message = "Vous n'êtes pas autorisé à effectuer cette action"
              _this.message_type = "alert-danger"
            } else {
              console.log(error)
            }
          })
          .then(function () {
                // always executed
              }
          );
    },

    activate: async function (id) {
      const _this = this;

      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/" + id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      // const form_element = new HTMLFormElement()
      const form_data = new FormData();

      form_data.append('aap[archived]', 0)

      axios({
        method: 'patch',
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.get_data()
            _this.message = "Projet activé"
            _this.message_type = "alert-success"
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    clone_project: async function (id) {
      const _this = this;
      if (confirm("Êtes vous certain de vouloir cloner cette candidature ?")) {
        let [secure_key, customer_id, api_url, customer] = await get_token_2()
        api_url += `aaps/${id}/clone.json`
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.get(api_url)
            .then(function (response) {
              _this.get_data()
            })
            .catch(function (error) {
              if (error.response.status === 401) {
                _this.message = "Vous n'êtes pas autorisé à effectuer cette action"
                _this.message_type = "alert-danger"
              } else {
                const field = Object.keys(error.response.data)[0]
                const error_message = error.response.data[field][0]
                _this.message = error_message;
                _this.message_type = "alert-danger";
              }
            })
            .then(function () {
                  // always executed
                }
            );
      }
    },

    destroy: async function (id) {
      const _this = this;
      if (confirm("Êtes vous certain de vouloir supprimer cette candidature ?")) {
        let [secure_key, customer_id, api_url, customer] = await get_token_2()
        api_url += "aaps/" + id + ".json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.delete(api_url)
            .then(function (response) {
              _this.get_data()
            })
            .catch(function (error) {
              if (error.response.status === 401) {
                _this.message = "Vous n'êtes pas autorisé à effectuer cette action"
                _this.message_type = "alert-danger"
              } else {
                console.log(error)
              }
            })
            .then(function () {
                  // always executed
                }
            );
      }
    },

    get_data: function () {
      this.wait_data = true

      this.get_statuses()
      this.get_aaps()
      this.get_commissions()
      this.get_comite_techniques()
      this.get_referents()
    },

    get_aaps: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer, admin] = await get_token_2()

      _this.admin = admin

      api_url += "aaps.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      api_url += '&page=' + _this.page
      api_url += '&archived=' + _this.show_archived
      api_url += '&deleted=' + _this.show_deleted
      api_url += '&status=' + _this.status_filter
      api_url += '&axes=' + _this.filter_axe
      api_url += '&referents=' + _this.filter_referent
      api_url += '&commissions=' + _this.filter_commission
      api_url += '&statut_juridiques=' + _this.filter_statut_juridique
      api_url += '&full_app=false'

      if (_this.query.length > 2) {
        api_url += '&search=' + _this.query
      }

      if (_this.view === 'chart') {
        api_url += '&no_pagination=true'
        api_url += '&reporting=true'
      }

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {

            if(_this.view === 'chart') {

              _this.montant_demande = response.data.report.montant_demande
              _this.montant_propose = response.data.report.montant_propose
              _this.montant_decide = response.data.report.montant_decide
              _this.montant_attribue = response.data.report.montant_attribue

              _this.demande_sante = response.data.report.demande_sante
              _this.demande_famille = response.data.report.demande_famille
              _this.demande_insertion = response.data.report.demande_insertion
              _this.demande_logement = response.data.report.demande_logement
              _this.demande_autonomie = response.data.report.demande_autonomie

              _this.chart_demande_data.datasets = [ { data: [
                  _this.demande_sante,
                  _this.demande_famille,
                  _this.demande_insertion,
                  _this.demande_logement,
                  _this.demande_autonomie
                ] } ]

              _this.propose_sante = response.data.report.propose_sante
              _this.propose_famille = response.data.report.propose_famille
              _this.propose_insertion = response.data.report.propose_insertion
              _this.propose_logement = response.data.report.propose_logement
              _this.propose_autonomie = response.data.report.propose_autonomie

              _this.chart_propose_data.datasets = [ { data: [
                  _this.propose_sante,
                  _this.propose_famille,
                  _this.propose_insertion,
                  _this.propose_logement,
                  _this.propose_autonomie
                ] } ]

              _this.decide_sante = response.data.report.decide_sante
              _this.decide_famille = response.data.report.decide_famille
              _this.decide_insertion = response.data.report.decide_insertion
              _this.decide_logement = response.data.report.decide_logement
              _this.decide_autonomie = response.data.report.decide_autonomie

              _this.chart_decide_data.datasets = [ { data: [
                  _this.decide_sante,
                  _this.decide_famille,
                  _this.decide_insertion,
                  _this.decide_logement,
                  _this.decide_autonomie
                ] } ]

              _this.attribue_sante = response.data.report.attribue_sante
              _this.attribue_famille = response.data.report.attribue_famille
              _this.attribue_insertion = response.data.report.attribue_insertion
              _this.attribue_logement = response.data.report.attribue_logement
              _this.attribue_autonomie = response.data.report.attribue_autonomie

              _this.chart_attribue_data.datasets = [ { data: [
                  _this.attribue_sante,
                  _this.attribue_famille,
                  _this.attribue_insertion,
                  _this.attribue_logement,
                  _this.attribue_autonomie
                ] } ]

            } else {
                _this.aaps = response.data.aaps
                _this.page = response.data.meta.page
                _this.page_count = response.data.meta.pages
                _this.aaps_count = response.data.meta.count
                _this.aaps_count = response.data.meta.count
                _this.from = response.data.meta.from
                _this.to = response.data.meta.to
            }

            _this.wait_data = false
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_commissions: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/commissions.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.commissions = response.data.commissions
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_comite_techniques: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/comite_techniques.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.comite_techniques = response.data.comite_techniques
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_referents: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/referents.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.referents = response.data.referents
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_statuses: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/statuses.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.statuses = response.data.statuses
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    set_date_commission: async function (id) {
      const _this = this

      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "aaps/" + id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      // const form_element = new HTMLFormElement()
      const form = document.getElementById('aap_commission_form_' + id)
      const form_data = new FormData(form);

      // form_data.append('aap[status]', value)

      axios({
        method: 'patch',
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.get_data()
            _this.message = "Date de commission mise à jour"
            _this.message_type = "alert-success"
          })
          .catch(function (error) {
            if (error.response.status === 401) {
              _this.message = "Vous n'êtes pas autorisé à effectuer cette action"
              _this.message_type = "alert-danger"
            } else {
              console.log(error)
            }

          })
          .then(function () {
                // always executed
              }
          );

    },

    set_date_comite_technique: async function (id) {
      const _this = this

      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "aaps/" + id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      const form = document.getElementById('aap_comite_technique_form_' + id)
      const form_data = new FormData(form);

      axios({
        method: 'patch',
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.get_data()
            _this.message = "Date de comite technique mise à jour"
            _this.message_type = "alert-success"
          })
          .catch(function (error) {
            if (error.response.status === 401) {
              _this.message = "Vous n'êtes pas autorisé à effectuer cette action"
              _this.message_type = "alert-danger"
            } else {
              console.log(error)
            }
          })
          .then(function () {
                // always executed
              }
          );

    },

    set_referent: function (id) {
      const _this = this

      get_token_2().then(function (response) {

        let [secure_key, customer_id, api_url, customer] = response
        api_url += "aaps/" + id + ".json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id


        // const form_element = new HTMLFormElement()
        const form = document.getElementById('aap_referent_form_' + id)
        const form_data = new FormData(form);


        axios({
          method: 'patch',
          url: api_url,
          data: form_data
        })
            .then(function (response) {
              _this.get_data()
              _this.message = "Référent mis à jour"
              _this.message_type = "alert-success"
            })
            .catch(function (error) {
              if (error.response.status === 401) {
                _this.message = "Vous n'êtes pas autorisé à effectuer cette action"
                _this.message_type = "alert-danger"
              } else {
                console.log(error)
              }
            })
            .then(function () {
                  // always executed
                }
            );

      })
    },

    set_status: async function (id) {
      const _this = this

      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/" + id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      // const form_element = new HTMLFormElement()
      const form = document.getElementById('aap_status_form_' + id)
      const form_data = new FormData(form);

      // form_data.append('aap[status]', value)

      axios({
        method: 'patch',
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.get_data()
            _this.message = "Statut mis à jour"
            _this.message_type = "alert-success"
          })
          .catch(function (error) {
            if (error.response.status === 401) {
              _this.message = "Vous n'êtes pas autorisé à effectuer cette action"
              _this.message_type = "alert-danger"
            } else {
              console.log(error)
            }
          })
          .then(function () {
                // always executed
              }
          );

    }
  }
}

</script>

<style scoped>

  .table td, .table th {
    padding: 0.1rem;
    vertical-align: top;
    border-top: .0625rem solid #e7eaf3;
  }

</style>
